// extracted by mini-css-extract-plugin
export default {"dropZone":"DropZoneURL_dropZone__Fni97","inputURL":"DropZoneURL_inputURL__FwDIF"};